import React from 'react'

export default function About(props) {
    // const [myStyle, setMyStyle] = useState({
    
    //     color:'black',
    //     backgroundColor:'white'
    // })
    let myStyle ={
      color:props.Mode==='dark'?'white':'#042743',
      backgroundColor:props.Mode==='dark'?'#042743':'white',
      // border:'2px solid',
      // borderColor:props.Mode==='dark'?'white':'black'
    }

    return (
        <div className="container" style={myStyle}>
            <h2 className="my-3" style={{color:props.Mode==='dark'?'white':'#042743'}}>About us</h2>
            <div className="accordion" id="accordionExample">
             <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button className="accordion-button" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapseOne" 
      aria-expanded="true" aria-controls="collapseOne">
        <strong>Anylaze your Text</strong>
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" 
    data-bs-parent="#accordionExample">
      <div className="accordion-body"style={myStyle}>
         hey this is cyphon text play website Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit nostrum, sint rem quaerat nam quis. Expedita officia maxime reiciendis eius.
      </div>
    </div>
  </div>
  <div className="accordion-item"style={myStyle}>
    <h2 className="accordion-header" id="headingTwo">
      <button className="accordion-button collapsed" type="button"style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapseTwo"
       aria-expanded="false" aria-controls="collapseTwo">
      <strong> Free To Use</strong>
      </button>     
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div className="accordion-body "style={myStyle}>
        <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
  <div className="accordion-item"style={myStyle}>
    <h2 className="accordion-header" id="headingThree">
      <button className="accordion-button collapsed" type="button"style={myStyle} data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
       <strong>Browser Compatible</strong>
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
      <div className="accordion-body"style={myStyle}>
        <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the
         <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
</div>
</div>
    )
}
